var _path, _polygon, _path2, _polygon2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _rect2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f289da69-e568-4792-9b3f-1219e3d998d1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 724.34614,
    height: 519,
    viewBox: "0 0 724.34614 519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M961.17307,709.5h-301a1,1,0,0,1,0-2h301a1,1,0,0,1,0,2Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "535.418 507.548 523.159 507.548 517.326 460.26 535.421 460.261 535.418 507.548",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M514.40147,504.04487h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H499.51461a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,514.40147,504.04487Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "624.374 493.661 613.222 498.754 588.269 458.165 604.727 450.648 624.374 493.661",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M844.32492,687.2145H867.9688a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H829.43807a0,0,0,0,1,0,0v0A14.88685,14.88685,0,0,1,844.32492,687.2145Z",
    transform: "translate(-449.7177 224.89624) rotate(-24.54855)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M826.498,538.605a10.05575,10.05575,0,0,0,.80112-15.39851l14.4116-32.69992-18.30864,3.10282-10.87858,30.57671A10.11027,10.11027,0,0,0,826.498,538.605Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M772.464,685.5794H760.75208a4.51685,4.51685,0,0,1-4.48828-4.17383L743.87683,510.847a4.49978,4.49978,0,0,1,4.9253-4.80469l73.73486,7.19336a4.50131,4.50131,0,0,1,4.06225,4.39355l1.41944,75.23535a3.492,3.492,0,0,0,.23388,1.19336l27.78516,72.05274a4.49892,4.49892,0,0,1-2.64307,5.84082l-11.8684,4.37305a4.50111,4.50111,0,0,1-5.55738-2.16407L801.8363,607.79131a4.47493,4.47493,0,0,1-.40429-1.14258L795.6012,578.555a3.49993,3.49993,0,0,0-6.90406.3125l-11.7622,102.72364A4.499,4.499,0,0,1,772.464,685.5794Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540.46895,
    cy: 162.42586,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M748.55066,511.83233c3.144,2.16894,38.56665,25.51172,78.94238,6.94531-.52319-4.50879-5.56152-49.7793-1.16089-83.15234,2.08765-15.834-4.21752-30.50293-17.29858-40.2461a49.73278,49.73278,0,0,0-50.02026-5.40136h-.00025q-.99426.44531-2.00244.92675Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M827.87634,518.40557a4.48617,4.48617,0,0,1-3.312-1.46l-5.37256-5.86133a4.52264,4.52264,0,0,1-.99829-4.31543l12.30493-41.64746L811.77625,425.805a8.33314,8.33314,0,0,1-.56958-5.54589,8.30927,8.30927,0,0,1,15.38745-1.96582l25.30932,41.06738a11.451,11.451,0,0,1,.6897,10.73047l-20.60986,45.665a4.48861,4.48861,0,0,1-3.38965,2.59179A4.56723,4.56723,0,0,1,827.87634,518.40557Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M766.72717,513.0794h-9.8125l17.12842-80.60352.98828.12891L771.22131,508.805A4.49651,4.49651,0,0,1,766.72717,513.0794Z",
    transform: "translate(-237.82693 -190.5)",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M757.6479,533.119a10.0558,10.0558,0,0,0-2.41343-15.22929l7.30826-34.97954-17.26545,6.83651-4.29307,32.16906A10.11028,10.11028,0,0,0,757.6479,533.119Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M756.65808,513.18a4.69328,4.69328,0,0,1-.50757-.02832l-10.4646-1.16308a4.515,4.515,0,0,1-3.99926-4.65821l4.32983-104.78222a13.52752,13.52752,0,0,1,26.73462-2.31543l2.78906,12.83008-.01367.09082L761.09754,509.346A4.48507,4.48507,0,0,1,756.65808,513.18Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M798.53211,374.5794c-2.5469.43668-4.64263-3.10848-4.95957-5.60213s.59189-4.88065.691-7.35813-1.0692-5.48813-3.64216-6.22268c-2.69746-.7701-5.198,1.39368-7.95937,1.13348-3.84789-.36258-5.77979-4.86573-6.24594-8.50854s-.83239-7.95675-4.16483-10.03412c-3.32214-2.07094-7.43185-.56414-11.24915-.49968-6.4517.10894-13.01929-4.81094-14.527-10.88235a3.65953,3.65953,0,0,0,4.1745-1.67179,3.70377,3.70377,0,0,0-1.1144-4.37824l7.31314,3.58106c-.99948-2.03411.51-4.35112,2.58767-5.12143s4.49481-.42436,6.78761-.06815c11.45045,1.77895,24.71315.90216,32.30847,9.6327,5.2609,6.04722,9.5914,17.55438,9,25S798.53211,374.5794,798.53211,374.5794Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M519.82656,651.5h-263a7.00787,7.00787,0,0,1-7-7L237.82693,197.52686A7.01308,7.01308,0,0,1,244.82656,190.5h263a7.00786,7.00786,0,0,1,7,7l2.17408,80.97314-1.999.05372-2.1748-81A5.01188,5.01188,0,0,0,507.82656,192.5h-263a5.00581,5.00581,0,0,0-5,5L251.8262,644.47314A5.01213,5.01213,0,0,0,256.82656,649.5h263a5.00573,5.00573,0,0,0,5-5l-2.3352-86.97314,1.99927-.05372,2.33569,87A7.01326,7.01326,0,0,1,519.82656,651.5Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 518.7377,
    y: 398.49308,
    width: 2.00023,
    height: 38.39957,
    transform: "translate(-248.84923 -176.40152) rotate(-1.53781)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M496.22647,612.10938H278.36709a5.977,5.977,0,0,1-5.97021-5.97022L262.45694,235.8877a5.98216,5.98216,0,0,1,5.96972-5.99707H486.286a5.977,5.977,0,0,1,5.97021,5.97021l1.8003,42.59717-1.99805.084-1.80127-42.63916a3.98544,3.98544,0,0,0-3.97119-4.0122H268.42666a3.97481,3.97481,0,0,0-3.97009,3.97021l9.93994,370.25146a3.98118,3.98118,0,0,0,3.97058,3.99708H496.22647a3.97483,3.97483,0,0,0,3.97021-3.97022l-1.28735-48.61279,1.99927-.05274,1.28759,48.63916A5.98191,5.98191,0,0,1,496.22647,612.10938Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 495.22905,
    y: 399.49334,
    width: 2.00021,
    height: 38.01331,
    transform: "translate(-248.72699 -177.22289) rotate(-1.51626)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M554.19668,399.5h-255a7.00778,7.00778,0,0,1-6.99975-6.94238L288.19668,284.5a7.00787,7.00787,0,0,1,7-7h255a7.00763,7.00763,0,0,1,6.99976,6.94238L561.19668,392.5A7.00786,7.00786,0,0,1,554.19668,399.5ZM290.19693,284.44727,294.19668,392.5a5.0058,5.0058,0,0,0,5,5h255a5.006,5.006,0,0,0,4.99976-4.94727L555.19668,284.5a5.00573,5.00573,0,0,0-5-5h-255A5.00587,5.00587,0,0,0,290.19693,284.44727Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M602.19668,558.5h-255a7.00778,7.00778,0,0,1-6.99975-6.94238L336.19668,443.5a7.00787,7.00787,0,0,1,7-7h255a7.00763,7.00763,0,0,1,6.99976,6.94238L609.19668,551.5A7.00786,7.00786,0,0,1,602.19668,558.5ZM338.19693,443.44727,342.19668,551.5a5.0058,5.0058,0,0,0,5,5h255a5.006,5.006,0,0,0,4.99976-4.94727L603.19668,443.5a5.00573,5.00573,0,0,0-5-5h-255A5.00587,5.00587,0,0,0,338.19693,443.44727Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M407.69668,460a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M407.69668,491a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M407.69668,522a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M359.69668,301a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M359.69668,332a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M359.69668,363a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z",
    transform: "translate(-237.82693 -190.5)",
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.36975,
    cy: 20,
    r: 10,
    fill: "#e6e6e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.911d53af8bb582b277c222a73ad3e402.svg";
export { ForwardRef as ReactComponent };